/*
 * @Author: LiaoYingLong
 * @Date: 2018-08-20 11:52:26
 * @Last Modified by:   LiaoYingLong
 * @Last Modified time: 2018-08-20 11:52:26
 */

import Vue from 'vue';
import videoPlayer from './index.vue';

const VideoPlayerConstructor = Vue.extend(videoPlayer);

let instance;
const initInstance = () => {
  instance = new VideoPlayerConstructor({
    el: document.createElement('div'),
  });
};

const VideoPlayer = function(options) {
  if (Vue.prototype.$isServer) return;
  if (!instance) {
    initInstance();
  }
  instance.visible = true;
  for (let k in options) {
    if (options.hasOwnProperty(k)) {
      instance[k] = options[k];
    }
  }
  document.body.appendChild(instance.$el);
};

export default VideoPlayer;
